module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container partner-signup"
  }, [_c('form-wizard', {
    ref: "wizard",
    attrs: {
      "shape": "tab",
      "back-button-text": "Go back!",
      "next-button-text": "Continue",
      "finish-button-text": "Sign Up",
      "color": "#eff9ff"
    },
    on: {
      "on-complete": _vm.onComplete,
      "on-change": _vm.scrollToTop
    }
  }, [_c('h1', {
    staticClass: "amcredit-font minimal-title text-center text-12-16 f-w-600 color-grey-5 uppercase ls-1",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Partner Program Sign Up")]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "icon": "far fa-hospital",
      "before-change": _vm.validateFirstTab
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Complete the form below to partner with the fastest growing provider of small business loans.")]), _vm._v(" "), _c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Business Owner Details")]), _vm._v(" "), _c('vue-form-generator', {
    ref: "businessOwnerForm",
    attrs: {
      "model": _vm.model,
      "schema": _vm.businessOwnerSchema,
      "options": _vm.formOptions
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Company Information")]), _vm._v(" "), _c('vue-form-generator', {
    ref: "companyInfoForm",
    attrs: {
      "model": _vm.model,
      "schema": _vm.companyInfoSchema,
      "options": _vm.formOptions
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "color-green"
  }, [_vm._v("About Your Company")]), _vm._v(" "), _c('vue-form-generator', {
    ref: "aboutCompanyForm",
    attrs: {
      "model": _vm.model,
      "schema": _vm.aboutCompanySchema,
      "options": _vm.formOptions
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "color-green"
  }, [_vm._v("Lending Experience")]), _vm._v(" "), _c('vue-form-generator', {
    ref: "lendingExpForm",
    attrs: {
      "model": _vm.model,
      "schema": _vm.lendingExpSchema,
      "options": _vm.formOptions
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3273134e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/PartnerSignUp.vue
// module id = 1969
// module chunks = 5